import Vue from 'vue';
// Initial State
const state = () => ({
    budget: {
        quotationId: null,
        cameFromBudget: false,
        cameFromHistory: false,
        plate: null,
        internalId: null,
        dataSourceId: null
    },

    planningDates: {
        startDate: null,
        endDate: null,
        stepDays: 1,
        oldStartDate: null,
        oldEndDate: null,
    },

    planningEvent: {},

    garagesAndUsers: {},

    servicesEstimate: {
      budgetData: {
        maintenance: [],
        operations: []
      },
      withIVA: false,
      entityCards: []
    },

    associatedQuotationId: null
});

// Mutations
const mutations = {
    setActiveReceptionPlanningBudgetState(state, payload) {
        state.budget.quotationId = payload.quotationId;
        state.budget.cameFromBudget = payload.cameFromBudget;
        state.budget.cameFromHistory = payload.cameFromHistory;
        state.budget.plate = payload.plate;
        state.budget.internalId = payload.internalId;
        state.budget.dataSourceId = payload.dataSourceId
    },

    setActiveReceptionPlanningQuotationId(state, payload) {
        state.budget.quotationId = payload;
    },

    setActiveReceptionPlanningCameFromBudget(state, payload) {
        state.budget.cameFromBudget = payload;
    },

    async setActiveReceptionPlanningDates(state, payload) {

        state.planningDates.oldStartDate = state.planningDates.startDate ? state.planningDates.startDate : payload.start;
        state.planningDates.oldEndDate = state.planningDates.endDate ? state.planningDates.endDate : payload.end;

        await Vue.nextTick(() => {
            state.planningDates.startDate = payload.start;
            state.planningDates.endDate = payload.end;
            state.planningDates.stepDays = payload.stepDays;
        });
    },

    setActiveReceptionGaragesUsersState(state, payload) {
        state.garagesAndUsers = payload;
    },

    setActiveReceptionPlanningEvent(state, payload) {
        state.planningEvent = payload;
        // localStorage.setItem('@datadrive:planning-event', JSON.stringify(payload));
        // this.dispatch('planning/updatePlanningLocalStorage');
    },

    setClearActiveReceptionPlanning(state, payload) {
        state.budget.quotationId = null;
        state.budget.cameFromBudget = false;
        state.budget.cameFromHistory = false;
        state.budget.plate = null;
        state.budget.internalId = null;
    },

    setActiveReceptionServicesEstimateBudgetData(state, payload) {
      state.servicesEstimate.budgetData = payload;
    },

    setActiveReceptionServicesEstimateMaintenance(state, payload) {
      state.servicesEstimate.budgetData.maintenance = payload;
    },

    setActiveReceptionServicesEstimateOperations(state, payload) {
      state.servicesEstimate.budgetData.operations = payload;
    },

    setActiveReceptionServicesEstimateSwitchIva(state, payload) {
      state.servicesEstimate.withIVA = payload;
    },

    setActiveReceptionServicesEstimateEntityCards(state, payload) {
      state.servicesEstimate.entityCards = payload;
    },

    setActiveReceptionServicesAssociatedQuotationId(state, payload) {
      state.associatedQuotationId = payload;
    }
  };

// Actions
const actions = {
    updateActiveReceptionPlanningLocalStorage(state) {
        localStorage.setItem('@datadrive:active-reception-planning-event', JSON.stringify(state.planningEvent));
    },
};

// Getters
const getters = {

    getActiveReceptionPlanningState(state) {
        for (var [key, value] of Object.entries(state)) {
            return state[key] = value;
        }
    },

    getActiveReceptionPlanningBudgetState(state) {
        return state.budget;
    },

    getActiveReceptionPlanningDates(state) {
        return state.planningDates;
    },

    getActiveReceptionGaragesUsers(state) {
        return state.garagesAndUsers;
    },

    getActiveReceptionPlanningEvent(state) {
        return state.planningEvent;
    },

    getActiveReceptionServicesEstimateMaintenance(state) {
      return state.servicesEstimate.budgetData.maintenance;
    },

    getActiveReceptionServicesEstimateOperations(state) {
      return state.servicesEstimate.budgetData.operations;
    },

    getActiveReceptionServicesEstimateSwitchIva(state) {
      return state.servicesEstimate.withIVA;
    },

    getActiveReceptionServicesEstimateEntityCards(state) {
      return state.servicesEstimate.entityCards;
    },

    getActiveReceptionServicesEstimate(state) {
      return state.servicesEstimate;
    },

    getActiveReceptionServicesAssociatedQuotationId(state) {
      return state.associatedQuotationId;
    },
  };

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
  };
